<template><SimpleModuleDashboard :module-id="Modules.PRECIOS" :profile-id="Profiles.PERSONAL" include-php-custom :actions="actions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default { components: { SimpleModuleDashboard }, data: () => ({ Modules, Profiles, actions: [
  { id: 'crudPricesLists', reference: 'crudPricesLists', route: 'PricesStaffCrudPricesLists', tone: 'primary' },
  { id: 'crudCurrency', reference: 'crudCurrency', route: 'PricesStaffCrudCurrency', tone: 'primary', group: 'Configuraciones' },
] }) }
</script>
